import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/meeting_room_master_action'
import moment from "moment";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
// import { NULL } from "sass";



class MeetingRoomMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            // currentPage: 1,
            meetingRoomMasterList: [],
            seaterList: [],
            deleteIdObj: {},
            deleteType: '',
            MstMeetingRoomID: null
        }
        this.getMeetingRoomMasterList = this.getMeetingRoomMasterList.bind(this)
        this.deleteMeetingRoomMaster = this.deleteMeetingRoomMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.onDelete = this.onDelete.bind(this)
    }

    componentDidMount() {
        this.getMeetingRoomMasterList()
    }

    getMeetingRoomMasterList(status) {
        this.setState({ isLoading: true })
        this.props.getMeetinRoomMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ meetingRoomMasterList: data.data })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteMeetingRoomMaster() {
        const { MstMeetingRoomID } = this.state
        this.setState({ isLoading: true })
        this.props.deleteMeetinRoomMaster_action(MstMeetingRoomID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    toastSuccess("deleted successfully")
                    this.setState({ MstMeetingRoomID: null }, () => {
                        this.getMeetingRoomMasterList()
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    // Handle Add 
    handleAdd(status) {
        this.props.navigate('/MeetingRoomMasterAU', { state: { status: status, MstMeetingRoomID: null } })
    }

    handleUpdate(MstMeetingRoomID, params, params2) {
        this.props.navigate('/MeetingRoomMasterAU', { state: { MstMeetingRoomID: MstMeetingRoomID, IsUpdate: params == 'update' ? 1 : 0, IsComboSlotAvailable: params != 'update' && params2 == 'Yes' ? 1 : 0 } })
    }

    onDelete(MstMeetingRoomID) {
        this.setState({ isOpen: true, MstMeetingRoomID: MstMeetingRoomID })
    }

    render() {
        const { isLoading, isOpen, meetingRoomMasterList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Meeting Room List</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                <div className="row m-0">
                                    <div className="table-responsive">
                                        <div className="table-responsive ">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" >Date</th>
                                                        <th className="text-center" >Room Type</th>
                                                        <th className="text-center" >Seating Capacity</th>
                                                        <th className="text-center" >Location </th>
                                                        <th className="text-center" >Slot</th>
                                                        <th className="text-center" >Price(INR)</th>
                                                        <th className="text-center" >Price(USD)</th>
                                                        <th className="text-center" >Combo Slot Available</th>
                                                        <th style={{ width: '60px' }} className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        meetingRoomMasterList.length > 0 ? (meetingRoomMasterList.map((data, i) => (
                                                            <tr key={i}>
                                                                <td className="text-center" >{moment.utc(data.Date).format('DD-MM-YYYY')}</td>
                                                                <td className="text-center" >{data.RoomTypeName}</td>
                                                                <td className="text-center" >{data.SeatingCapacity}</td>
                                                                <td className="text-center" >{data.Location}</td>
                                                                <td className="text-center" >{moment.utc(data.FromTime).format('hh:mm A')} - {moment.utc(data.ToTime).format('hh:mm A')}</td>
                                                                <td className="text-center" >{data.RateInINR}</td>
                                                                <td className="text-center" >{data.RateInUSD}</td>
                                                                <td className="text-center" >{data.IsComboSlotAvailable}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline btn-sm"
                                                                        onClick={(e) => this.handleUpdate(data.MstMeetingRoomID, 'update', data.IsComboSlotAvailable)}
                                                                    >
                                                                        <i className="fa fa-pencil action_btn_table" />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline btn-sm"
                                                                        onClick={() => this.handleUpdate(data.MstMeetingRoomID, 'replicate', data.IsComboSlotAvailable)}
                                                                    >
                                                                        <i
                                                                            class="fa fa-clone grid-icon"
                                                                            title="Replicate Meeting Room"
                                                                        />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline btn-sm text-danger"
                                                                        onClick={(e) => this.onDelete(data.MstMeetingRoomID)}
                                                                    >
                                                                        <i className="fa fa-trash action_btn_table" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))) : <tr><td className="text-center" colSpan={20}>No record found</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="text-end mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.handleAdd()}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteMeetingRoomMaster()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action })(MeetingRoomMasterList));